// extracted by mini-css-extract-plugin
export var button = "_k2-0";
export var donut = "_k2-1";
export var donutFill = "_k2-3";
export var donutTrack = "_k2-2";